<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal_form_tifsitio_export"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar listado Tif Sitios</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Columnas"
                  data-toggle="tab"
                  href="#Columnas"
                  >Columnas</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane" id="Filtros">
                <div class="card-body">
                  <div class="form-group row">
                    <label for="nombre" class="col-md-5">Nombre</label>

                    <input
                      type="text"
                      id="nombre"
                      v-model="filtros.nombre"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="direccion" class="col-md-5">Direccion</label>
                    <input
                      type="text"
                      id="direccion"
                      v-model="filtros.direccion"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="geocerca_zona_id" class="col-md-5"
                      >Geocerca Zona</label
                    >
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="geocerca_zona"
                      placeholder="Geocerca Zona"
                      label="nombre"
                      class="form-control form-control-sm p-0 col-md-7"
                      :options="listasForms.geocercas_zonas"
                      :filterable="true"
                      @input="getSelectGeocercaZona()"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label for="telefono" class="col-md-5">Telefono</label>
                    <input
                      type="number"
                      id="telefono"
                      v-model="filtros.telefono"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="tipo_sitio" class="col-md-5"> Tipo Sitio</label>
                    <select
                      id="tipo_sitio"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.tipo_sitio"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="tipo_sitio in listasForms.tipos_sitio"
                        :key="tipo_sitio.numeracion"
                        :value="tipo_sitio.numeracion"
                      >
                        {{ tipo_sitio.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="estado1" class="col-md-5"> Estado</label>
                    <select
                      id="estado"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.estado"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="estado in listasForms.estados"
                        :key="estado.numeracion"
                        :value="estado.numeracion"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade active show" id="Columnas">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-11">
                      <div class="form-group">
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="nombre1"
                              v-model="form.nombre"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="nombre1"
                              >Nombre</label
                            >
                          </div>
                        </div>

                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="nombre_contacto"
                              v-model="form.nombre_contacto"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="nombre_contacto"
                              >Nombre Contacto</label
                            >
                          </div>
                        </div>

                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="geocerca_zona_id"
                              v-model="form.geocerca_zona_id"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="geocerca_zona_id"
                              >Geocerca Zona</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="direccion1"
                              v-model="form.direccion"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="direccion1"
                              >Dirrección</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="telefono1"
                              v-model="form.telefono"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="telefono1"
                              >Telefono</label
                            >
                          </div>
                        </div>

                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="celular"
                              v-model="form.celular"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="celular"
                              >Celular</label
                            >
                          </div>
                        </div>

                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="tipo_sitio1"
                              v-model="form.tipo_sitio"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="tipo_sitio1"
                              >Tipo de Sitio</label
                            >
                          </div>
                        </div>

                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="capacidad_max"
                              v-model="form.capacidad_max"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="capacidad_max"
                              >Capacidad Máxima</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="estado1"
                              v-model="form.estado"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="estado1"
                              >Estado</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                @click="generarListadoExcel()"
                v-if="$store.getters.can('tif.sitios.export')"
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";
export default {
  name: "TifSitiosExport",
  components: {
    Loading,
    vSelect,
  },
  data() {
    return {
      cargando: false,
      geocerca_zona: {},
      form: {
        nombre: true,
        geocerca_zona_id: true,
        direccion: true,
        tipo_sitio: true,
        telefono: true,
        capacidad_max: true,
        celular: true,
        nombre_contacto: true,
        estado: true,
      },
      filtros: {
        nombre: null,
        geocerca_zona_id: null,
        direccion: null,
        telefono: null,
        tipo_sitio: null,
        estado: null,
      },
      listasForms: {
        geocercas_zonas: [],
        tipos_sitio: [],
        estados: [],
      },
    };
  },

  methods: {
    async getGeocercaZona() {
      await axios
        .get("/api/admin/basico/geocercaZona/lista")
        .then((response) => {
          this.listasForms.geocercas_zonas = response.data;
        });
    },

    getSelectGeocercaZona() {
      this.filtros.geocerca_zona = {};
      this.filtros.geocerca_zona_id = null;
      if (this.geocerca_zona) {
        this.filtros.geocerca_zona = this.geocerca_zona;
        this.filtros.geocerca_zona_id = this.geocerca_zona.id;
      }
    },

    getTipoSitio() {
      axios.get("/api/lista/95").then((response) => {
        this.listasForms.tipos_sitio = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    generarListadoExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/tif/sitios/export",
        data: { form: this.form, filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },

  async mounted() {
    this.cargando = true;
    await this.getGeocercaZona();
    await this.getTipoSitio();
    await this.getEstados();
    this.cargando = false;
  },
};
</script>
